import { useSelector } from 'react-redux';
import { Currency } from '../../models';
import { selectCurrencies } from '../../selectors';

export const useCurrencies = (): Currency[] => {
  const currencies = useSelector(selectCurrencies);

  return currencies;
};
